"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION = void 0;
/** Actions possible */
var ACTION;
(function (ACTION) {
    ACTION["CREATE"] = "create";
    ACTION["ADD_PAYMENT_ADDRESS"] = "addPaymentAddress";
    ACTION["ADD_REFUND_ADDRESS"] = "addRefundAddress";
})(ACTION || (exports.ACTION = ACTION = {}));
//# sourceMappingURL=pn-any-address-based-types.js.map